const PERKS_EARLY_ACCESS_TAG_NAME = 'Perks Early Access';
const PERKS_EXCLUSIVE_DEAL_TAG_NAME = 'Perks Deal';

export const getPerksDealStatusFromTags = (
  tags: Array<string>
): { isPerksEarlyAccess: boolean; isPerksExclusiveDeal: boolean } => {
  const isPerksEarlyAccess = !!tags.find(tag => tag === PERKS_EARLY_ACCESS_TAG_NAME);
  const isPerksExclusiveDeal = !!tags.find(tag => tag === PERKS_EXCLUSIVE_DEAL_TAG_NAME);
  return { isPerksEarlyAccess, isPerksExclusiveDeal };
};
